;(function() {
  'use strict'

  elementsService.$inject = ["$rootScope", "$q", "AUTH_EVENTS", "elementsResource", "elementSourcesResource", "userElementsResource", "locationService", "$log"];
  angular.module('core.services').factory('elementsService', elementsService)

  // --------------------

  /* @ngInject */
  function elementsService(
    $rootScope,
    $q,
    AUTH_EVENTS,
    elementsResource,
    elementSourcesResource,
    userElementsResource,
    locationService,
    $log
  ) {
    var log = $log.create('elementsService')
    var nextLookup
    var lastElement
    var followingIds = []

    var types = [
      'place', // finds via foursquare
      'product', // finds by `title` + `type=product` in elements
      'code', // finds by `sourceId` in elements
      'other', // finds by `title` + `type=other` in elements
    ]

    var defaultFeatureImages = {
      place: './img/ele-bg-place.png',
      product: './img/ele-bg-product.png',
      other: './img/ele-bg-other.png',
      code: './img/ele-bg-other.png',
    }

    /**
     * get following on login success
     */
    $rootScope.$on(AUTH_EVENTS.loginSuccess, function() {
      getFollowing()
    })

    /**
     * clear following on logout success
     */
    $rootScope.$on(AUTH_EVENTS.logoutSuccess, function() {
      clearFollowing()
    })

    return {
      search: search,
      getByPage: getByPage,
      getById: getById,
      getByLookup: getByLookup,
      setNextLookup: setNextLookup,
      getNextLookup: getNextLookup,
      subtext: subtext,
      getFollowing: getFollowing,
      storeFollowing: storeFollowing, // todo: UNDO_HACK_FOLLOWING
      follow: follow,
      unfollow: unfollow,
      getLast: getLast,
      clearFollowing: clearFollowing,
      getNearMe: getNearMe,
      create: create,
    }

    // --------------------

    function search(query, limit, options) {
      return $q(function(resolve, reject) {
        options = options || {}

        // make requests for each type, and add promises to an array
        var promises = []

        _.each(options.types || types, function(type) {
          promises.push(searchByType(type, query, limit))
        })

        // deferr until all promises resolve
        $q.all(promises).then(
          function(data) {
            var results = {}
            results.all = []
            results.all = aggregate(data)

            // split them into types
            _.each(results.all, function(result) {
              // if type doesnt exist, create it
              if (!results[result.type]) {
                results[result.type] = []
              }
              results[result.type].push(result)
            })

            results.all = prioritiseResults(results.all, query)

            log.log('search tabs', results)
            resolve(results)
          },
          function(err) {
            reject(err)
          }
        )
      })
    }

    function prioritiseResults(results, query) {
      // Priority order is:
      // 1. Exact match and Registered
      // 2. Exact match
      // 3. Registered
      // 4. ...everything else

      var newResults = [].concat(
        removeResults(isExactAndRegisteredMatch),
        removeResults(isExactMatch),
        removeResults(isRegisteredMatch),
        results
      )

      function removeResults(conditionFn) {
        return _.remove(results, function(result) {
          // log.log('removing with ', conditionFn, conditionFn(result));
          return conditionFn(result)
        })
      }

      function isExactAndRegisteredMatch(result) {
        return (
          result.isSubscriberOwned &&
          result.name.toLowerCase() === query.toLowerCase()
        )
      }

      function isExactMatch(result) {
        return result.name.toLowerCase() === query.toLowerCase()
      }

      function isRegisteredMatch(result) {
        return result.isSubscriberOwned
      }

      return newResults
    }

    function aggregate(data) {
      data = JSON.parse(JSON.stringify(data)) // deep clone
      var aggregateData = []
      var sets = data.length
      var totalCount = 0
      var cursor = 0 // horizontal cursor across each set

      // get total count
      _.each(data, function(item) {
        totalCount += item.length
      })

      // literally pulls an item from the top of each set
      // until they are all merged
      while (aggregateData.length < totalCount) {
        if (data[cursor][0]) {
          aggregateData.push(data[cursor].shift())
        }
        nextCursor()
      }

      function nextCursor() {
        if (cursor === sets - 1) {
          cursor = 0
        } else {
          cursor++
        }
      }

      return aggregateData
    }

    function searchByType(type, query, limit) {
      return $q(function(resolve, reject) {
        var position = locationService.latest.encoded || {}

        elementSourcesResource
          .get({
            type: type,
            query: query,
            limit: limit || 5,
            location: position,
          })
          .success(function(elements, data) {
            addExtras(data, true)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              type: type,
              data: data,
              status: status,
            })
          })
      })
    }

    function getById(id) {
      return $q(function(resolve, reject) {
        elementsResource
          .get({
            id: id,
          })
          .success(function(res, data) {
            addExtras([data])
            lastElement = data
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function setNextLookup(element) {
      log.log('nextLookup', element)
      // valid
      if (element.type && (element.elementId || element.id)) {
        nextLookup = element
        return true
      }
      // invalid
      nextLookup = null
      return false
    }

    function getNextLookup() {
      return nextLookup
    }

    function getByLookup() {
      return $q(function(resolve, reject) {
        if (!nextLookup) {
          return reject()
        }

        // We have to do lookUp's like this due to user not specifically being logged in.
        if (nextLookup.elementId) {
          getById(nextLookup.elementId).then(
            function(element) {
              resolve(element)
            },
            function() {
              reject({})
            }
          )
        } else {
          var data = {
            type: nextLookup.type,
            elementItemId: nextLookup.id,
          }
          elementsResource
            .create(data)
            .success(function(res, data) {
              if (!data.id) {
                reject({})
              } else {
                getById(data.id).then(
                  function(element) {
                    addExtras([element])
                    resolve(element)
                  },
                  function() {
                    reject({})
                  }
                )
              }
            })
            .error(function(data, status) {
              reject({
                data: data,
                status: status,
              })
            })
        }
      })
    }

    function getByPage(pageId) {
      return $q(function(resolve, reject) {
        elementsResource
          .get({ pageId: pageId })
          .success(function(x, elements) {
            addExtras(elements)

            // DEBUG: fake many results
            // var els = [];
            // _.times(100, function () {
            //     // elements[0].type = 'product';
            //     els.push(_.cloneDeep(elements[0]));
            // });
            // var foo = _.cloneDeep(elements[0]);
            // foo.extras.title = 'I am foo dude';
            // els.push(foo);
            // elements = els;

            resolve(elements)
          })
          .error(function(response, status) {
            reject({
              response: response,
              status: status,
            })
          })
      })
    }

    function subtext(element) {
      if (element.type === 'product') {
        return element.brand
      } else if (element.type === 'place') {
        var location = element.location || element.placeData || element
        if (!location) {
          return ''
        }
        var address = location.address ? location.address + ', ' : ''
        var city = location.city ? location.city + ', ' : ''
        var state = location.state || ''
        return address + city + state
      }
    }

    function getLogoStyles(element) {
      var styles = {}
      styles['background-image'] = 'url(' + element.imageUrl + ')'
      if (
        _.includes(element.imageUrl, '/img/categories') ||
        _.includes(element.imageUrl, '.white.orange.svg')
      ) {
        styles['background-size'] = '70%'
      } else {
        styles['background-color'] = 'transparent'
      }
      return styles
    }

    function getFeatureStyles(element) {
      var styles = {}
      // glow app default
      if (
        !element.featureImageUrl &&
        element.id === '027c9c7f-c5a7-4b8e-935d-48778838c88a'
      ) {
        element.featureImageUrl =
          'http://static.glowfeed.com/img/element-logos/glow-app-element-feature.png'
      }
      element.featureImageUrl =
        element.featureImageUrl || defaultFeatureImages[element.type]
      styles['background-image'] = 'url(' + element.featureImageUrl + ')'
      return styles
    }

    function addExtras(elements, isElementSource) {
      _.each(elements, function(element) {
        element.extras = {}
        element.extras.isElementSource = isElementSource
        element.extras.title = element.name || element.title
        element.extras.logoStyles = getLogoStyles(element)
        element.extras.subtext = subtext(element)
        if (element.extras.subtext) {
          element.extras.subtextShort =
            element.extras.subtext.length > 50
              ? element.extras.subtext.substr(0, 50 - 1) + '...'
              : element.extras.subtext
        }
        element.extras.featureStyles = getFeatureStyles(element)
        element.extras.surveys = findOpenSurveys(element)
        element.extras.quickSurvey = findQuickSurvey(element)
        element.extras.npsSurvey = (
          _.find(element.surveys, { type: 'nps' }) || {}
        ).id
        element.extras.canClaim = element.claimState !== 'CLAIMED'
        element.userFollowing = _.includes(followingIds, element.id) // todo: UNDO_HACK_FOLLOWING
      })
    }

    function findOpenSurveys(element) {
      var surveys = []
      if (element.isPrivate) {
        return []
      }
      _.each(element.surveys, function(survey) {
        if (!survey.isArchived && survey.isPromoted) {
          surveys.push(survey)
        }
      })
      return surveys
    }

    function findQuickSurvey(element) {
      if (element.extras.surveys[0]) {
        return element.extras.surveys[0].id
      }
    }

    function getFollowing() {
      return $q(function(resolve, reject) {
        userElementsResource
          .get()
          .success(function(res, data) {
            storeFollowing(data)
            addExtras(data)
            resolve(followingIds)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function storeFollowing(elements) {
      angular.copy(elements, followingIds)
    }

    function follow(elementId, elementType) {
      return $q(function(resolve, reject) {
        followingIds.push(elementId)
        userElementsResource
          .create({
            elementId: elementId,
            type: elementType,
          })
          .success(function() {
            resolve()
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function unfollow(elementId) {
      return $q(function(resolve, reject) {
        var index = _.indexOf(followingIds, elementId)
        if (index !== -1) {
          followingIds.splice(index, 1)
        }
        userElementsResource
          .delete({ id: elementId })
          .success(function() {
            resolve()
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function clearFollowing() {
      angular.copy([], followingIds)
    }

    function getLast() {
      return lastElement
    }

    function getNearMe(limit) {
      return $q(function(resolve, reject) {
        elementSourcesResource
          .get({
            type: 'near',
            limit: limit || 10,
            location: locationService.latest.encoded,
          })
          .success(function(elements, data) {
            addExtras(data, true)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function create(data) {
      return $q(function(resolve, reject) {
        elementsResource
          .createSecure(data)
          .success(function(res, data) {
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }
  }
})()
